var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.3C2 7.61984 2 6.77976 2.36331 6.13803C2.68289 5.57354 3.19282 5.1146 3.82003 4.82698C4.53307 4.5 5.46649 4.5 7.33333 4.5H16.6667C18.5335 4.5 19.4669 4.5 20.18 4.82698C20.8072 5.1146 21.3171 5.57354 21.6367 6.13803C22 6.77976 22 7.61984 22 9.3V17.7C22 19.3802 22 20.2202 21.6367 20.862C21.3171 21.4265 20.8072 21.8854 20.18 22.173C19.4669 22.5 18.5335 22.5 16.6667 22.5H7.33333C5.46649 22.5 4.53307 22.5 3.82003 22.173C3.19282 21.8854 2.68289 21.4265 2.36331 20.862C2 20.2202 2 19.3802 2 17.7V9.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 14.5L12 13.5V18.5",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6111 18.5H13.3889Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5H2M16.4444 2.5V6.5M7.55556 2.5V6.5M10.3333 14.5L12 13.5V18.5M10.6111 18.5H13.3889M7.33333 22.5H16.6667C18.5335 22.5 19.4669 22.5 20.18 22.173C20.8072 21.8854 21.3171 21.4265 21.6367 20.862C22 20.2202 22 19.3802 22 17.7V9.3C22 7.61984 22 6.77976 21.6367 6.13803C21.3171 5.57354 20.8072 5.1146 20.18 4.82698C19.4669 4.5 18.5335 4.5 16.6667 4.5H7.33333C5.46649 4.5 4.53307 4.5 3.82003 4.82698C3.19282 5.1146 2.68289 5.57354 2.36331 6.13803C2 6.77976 2 7.61984 2 9.3V17.7C2 19.3802 2 20.2202 2.36331 20.862C2.68289 21.4265 3.19282 21.8854 3.82003 22.173C4.53307 22.5 5.46649 22.5 7.33333 22.5Z",
    stroke: "#262E45",
    strokeWidth: 1.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar-date.5684a96f0baa8b2d6bf1fb65193d6567.svg";
export { ForwardRef as ReactComponent };